import { connect } from "react-redux";
import { mapStateToProps, mapDispatchToProps } from "./ForgotPassword.state";
import ForgotPassword from "./ForgotPassword.query";

export default connect(mapStateToProps, mapDispatchToProps)(ForgotPassword);
